import React from 'react'
import { Box } from "@mui/material"
import { ButtonLoadingSeeker } from "@ui-seeker/core"
import { useCatalogueDetailsForm } from '../@hooks'


export default function CustomMappingToolbarSelect({ selectedData, setSelectedRows }) {
    const { handleOpenFormMultiple, isLoadingDrawer } = useCatalogueDetailsForm()

	return <Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end", mr: 2.5 }}>
		<ButtonLoadingSeeker
			icon="trash"
			iconWeight="solid"
            loading={isLoadingDrawer}
            tooltip="Edit multiple mappings"
            onClick={() => handleOpenFormMultiple(selectedData)}
		>
            Edit Multiple
        </ButtonLoadingSeeker>
	</Box>
}